<template>
  <v-card color="kbWhite" class="mt-4">
    <v-card-title class="kbDarkBlueText--text">
      3. {{ $t('general.triggers') }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12"
               v-for="(trigger, index) in triggers"
               :key="index">
          <TriggerCard
            :selectedRuleSequenceId="selectedRuleSequenceId"
            :trigger="trigger"
            @addAction="addAction(index)"
            @deleteAction="deleteAction({ actionIndex: $event, triggerIndex: index })"
            @deleteTrigger="deleteTrigger(index)"
          />
        </v-col>

        <v-col cols="12" class="pb-0">
          <div>
            <v-btn
              color="kbBlue"
              dark
              small
              @click="addTrigger()"
            >
              {{ $t('general.addTrigger') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TriggerCard from '@/pages/App/Sequences/Rules/dialogs/CreateEditRule/TriggerCard'
export default {
  components: { TriggerCard },
  methods: {
    addAction (triggerIndex) {
      this.$emit('addAction', triggerIndex)
    },
    addTrigger () {
      this.$emit('addTrigger')
    },
    deleteAction ({ actionIndex, triggerIndex }) {
      this.$emit('deleteAction', { actionIndex, triggerIndex })
    },
    deleteTrigger (index) {
      this.$emit('deleteTrigger', index)
    }
  },
  props: {
    selectedRuleSequenceId: {
      type: String,
      default: ''
    },
    triggers: {
      type: Array,
      default: () => []
    }
  }
}
</script>
